/* LicensedTime category and gift pages: AJAX filtering, Load more, team facet (live teams only), My team toggle, mobile filter panel. */
(() => {
  'use strict';
  const root = document.querySelector('[data-lt-category]');
  if (!root) return;

  const $ = (s, r) => (r || root).querySelector(s);
  const $$ = (s, r) => Array.from((r || root).querySelectorAll(s));
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const hex = (h) => (typeof h === 'string' && /^#[0-9a-f]{3,8}$/i.test(h) ? h : '');
  const mobile = window.matchMedia('(max-width: 1023px)');
  let panelOpen = false;
  let opener = null;
  let busy = false;

  /* ---------- team facet: live teams only, color dots, search, "[n] more schools coming soon" ---------- */
  const teamFacet = () => {
    const LT = window.LT;
    const facet = $('[data-lt-team-facet]');
    if (!LT || !LT.teams || !facet) return;
    const byName = new Map(LT.teams.map((t) => [t.n.toLowerCase(), t]));
    // Shopify caps a storefront filter at 100 values, so a live team can be missing from the list. For a text filter
    // (custom.team_name) the value is the team's display name, so add any missing live team ourselves.
    const firstInput = $('.lt-opt--team input', facet);
    const param = firstInput ? firstInput.name : '';
    const byGid = /custom\.team$/.test(param);
    if ((param.includes('team_name') || byGid) && !facet.dataset.filled) {
      facet.dataset.filled = '1';
      const present = new Set($$('.lt-opt--team', facet).map((o) => (o.dataset.teamLabel || '').toLowerCase()));
      const selected = new URLSearchParams(window.location.search).getAll(param);
      const anchor = $('[data-lt-soon]', facet);
      LT.teams
        .filter((t) => t.live && !present.has(t.n.toLowerCase()))
        .forEach((t) => {
          // text filter (custom.team_name): the value is the display name; metaobject filter (custom.team): the metaobject GID
          const value = byGid ? `gid://shopify/Metaobject/${t.id}` : t.n;
          const label = document.createElement('label');
          label.className = 'lt-opt lt-opt--team';
          label.dataset.teamLabel = t.n;
          label.hidden = true;
          label.innerHTML = `<input type="checkbox" name="${esc(param)}" value="${esc(value)}"${selected.includes(value) ? ' checked' : ''}><span class="lt-dot" data-dot aria-hidden="true"></span><span class="lt-opt__label">${esc(t.n)}</span><span class="lt-opt__count"></span>`;
          facet.insertBefore(label, anchor);
        });
    }
    let shownCount = 0;
    $$('.lt-opt--team', facet).forEach((opt) => {
      const t = byName.get((opt.dataset.teamLabel || '').toLowerCase());
      const isLive = !!(t && t.live);
      opt.hidden = !isLive;
      opt.dataset.live = isLive ? '1' : '0';
      if (isLive) {
        shownCount += 1;
        const dot = $('[data-dot]', opt);
        if (dot && hex(t.p)) dot.style.background = t.p;
      }
    });
    const soon = $('[data-lt-soon]', facet);
    const n = LT.teams.filter((t) => !t.live).length;
    if (soon) {
      soon.hidden = n === 0;
      soon.textContent = `${n} more school${n === 1 ? '' : 's'} coming soon`;
    }
    if (!shownCount) facet.hidden = true;
    // My team toggle
    const mine = $('[data-lt-mine]');
    const my = LT.getMyTeam();
    if (mine) {
      const opt = my && my.live ? $$('.lt-opt--team', facet).find((o) => (o.dataset.teamLabel || '').toLowerCase() === my.n.toLowerCase() && o.dataset.live === '1') : null;
      mine.hidden = !opt;
      if (opt) {
        const input = $('input', opt);
        const others = $$('.lt-opt--team input', facet).filter((i) => i !== input && i.checked).length;
        const on = input.checked && others === 0;
        mine.setAttribute('aria-pressed', String(on));
        mine.dataset.team = my.n;
        $('[data-lt-mine-label]', mine).textContent = on ? `Showing ${my.s} only` : `Show only ${my.s}`;
        const d = $('.lt-dot', mine);
        if (d) d.style.background = hex(my.p) || '#16181b';
        mine.style.setProperty('--mine', hex(my.p) || '#16181b');
        mine.style.setProperty('--mine-on', hex(my.op) || '#ffffff');
      }
    }
  };

  const badge = () => {
    const form = $('[data-lt-form]');
    const b = $('[data-lt-badge]');
    if (!form || !b) return;
    let n = $$('input:checked', form).filter((i) => i.name !== 'sort_by').length;
    $$('input[type=number]', form).forEach((i) => {
      if (i.value !== '') n += 1;
    });
    b.hidden = n === 0;
    b.textContent = String(n);
  };

  /* ---------- AJAX navigation ---------- */
  const paramsFrom = (form, override) => {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => {
      if (v !== '') params.append(k, v);
    });
    if (override) Object.keys(override).forEach((k) => params.set(k, override[k]));
    // leave the default sort and empty or zero prices out of the URL
    if (params.get('sort_by') === root.dataset.defaultSort) params.delete('sort_by');
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => {
      if (params.has(k) && !(Number(params.get(k)) > 0)) params.delete(k);
    });
    return params;
  };
  const urlFor = (params) => {
    const base = root.dataset.collectionUrl;
    // keep a ?view= template preview when present
    const view = new URLSearchParams(window.location.search).get('view');
    if (view && !params.has('view')) params.set('view', view);
    const q = params.toString();
    return q ? `${base}?${q}` : base;
  };

  // A team that Shopify left out of the filter list (100-value cap) has no server-rendered chip; add one.
  const ensureChips = () => {
    const bar = $('.lt-cat__bar');
    const form = $('[data-lt-form]');
    if (!bar || !form) return;
    const have = $$('.lt-chip-x', bar).map((c) => c.textContent.trim().toLowerCase());
    let added = false;
    $$('.lt-opt--team input:checked', form).forEach((input) => {
      const labelText = ($('.lt-opt__label', input.closest('label')) || {}).textContent || input.value;
      if (have.includes(labelText.trim().toLowerCase())) return;
      const params = new URLSearchParams(window.location.search);
      const rest = params.getAll(input.name).filter((v) => v !== input.value);
      params.delete(input.name);
      rest.forEach((v) => params.append(input.name, v));
      params.delete('page');
      const a = document.createElement('a');
      a.className = 'lt-chip-x';
      a.setAttribute('data-lt-nav', '');
      a.href = urlFor(params);
      a.innerHTML = `${esc(labelText.trim())} <svg width="10" height="10" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16"></path></svg>`;
      bar.insertBefore(a, $('.lt-sort', bar));
      added = true;
    });
    if (added && !$('.lt-linkbtn', bar)) {
      const clear = document.createElement('a');
      clear.className = 'lt-linkbtn';
      clear.setAttribute('data-lt-nav', '');
      clear.href = urlFor(new URLSearchParams());
      clear.textContent = 'Clear all';
      bar.insertBefore(clear, $('.lt-sort', bar));
    }
  };

  const afterRender = () => {
    teamFacet();
    ensureChips();
    badge();
    capLists();
    if (panelOpen) $('[data-lt-filterpanel]').classList.add('is-open');
  };

  const navigate = async (url, push = true) => {
    if (busy) return;
    busy = true;
    root.classList.add('is-loading');
    const body = $('[data-lt-filterpanel] .lt-cat__pbody');
    const scroll = body ? body.scrollTop : 0;
    const teamSearch = $('[data-lt-team-search]');
    const searchValue = teamSearch ? teamSearch.value : '';
    const focusName = document.activeElement && document.activeElement.name;
    const focusValue = document.activeElement && document.activeElement.value;
    try {
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-lt-category]');
      if (!next) {
        window.location.assign(url);
        return;
      }
      root.innerHTML = next.innerHTML;
      if (push) window.history.pushState({}, '', url);
      afterRender();
      const nb = $('[data-lt-filterpanel] .lt-cat__pbody');
      if (nb) nb.scrollTop = scroll;
      const ts = $('[data-lt-team-search]');
      if (ts && searchValue) {
        ts.value = searchValue;
        filterTeams(searchValue);
        capLists();
      }
      if (focusName) {
        const el = $$('input, select').find((e) => e.name === focusName && (e.type === 'checkbox' || e.type === 'radio' ? e.value === focusValue : true));
        if (el && !el.disabled) el.focus({ preventScroll: true });
      }
      const count = $('[data-lt-count]');
      if (count) count.focus && count.setAttribute('tabindex', '-1');
    } catch (e) {
      window.location.assign(url);
    } finally {
      busy = false;
      root.classList.remove('is-loading');
    }
  };
  window.addEventListener('popstate', () => navigate(window.location.href, false));

  const filterTeams = (q) => {
    const needle = q.trim().toLowerCase();
    $$('.lt-opt--team').forEach((o) => {
      if (o.dataset.live !== '1') return;
      o.hidden = needle !== '' && !(o.dataset.teamLabel || '').toLowerCase().includes(needle);
    });
  };

  /* ---------- cap every facet list at 10 values, with Show more ---------- */
  const CAP = 10;
  const expandedFacets = new Set();
  (() => {
    const st = document.createElement('style');
    st.textContent = '.lt-capped{display:none!important}.lt-showmore{display:inline-flex;align-items:center;margin:8px 0 0;padding:6px 0;background:none;border:0;font:inherit;font-size:14px;font-weight:600;color:inherit;text-decoration:underline;cursor:pointer}.lt-showmore[hidden]{display:none}';
    document.head.appendChild(st);
  })();
  const capGroups = [
    { box: '.lt-facet--team', items: '.lt-opt--team', team: true },
    { box: '.lt-optlist', items: '.lt-opt' },
    { box: '.lt-pills', items: '.lt-pill' },
    { box: '.lt-swatchrow', items: '.lt-sw' },
    { box: '.lt-styles', items: '.lt-style' },
  ];
  const facetKey = (box) => {
    const f = box.closest('fieldset, details') || box;
    const l = f.querySelector('legend, summary');
    return ((l && l.textContent) || box.className).trim();
  };
  const capLists = () => {
    const search = $('[data-lt-team-search]');
    const q = search ? search.value.trim() : '';
    capGroups.forEach((g) => {
      $$(g.box).forEach((box) => {
        const all = $$(g.items, box).filter((el) => el.closest(g.box) === box);
        all.forEach((el) => el.classList.remove('lt-capped'));
        let btn = g.team ? box.querySelector('[data-lt-showmore]') : (box.nextElementSibling && box.nextElementSibling.matches('[data-lt-showmore]') ? box.nextElementSibling : null);
        if (!btn) {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lt-showmore';
          btn.setAttribute('data-lt-showmore', '');
          btn.hidden = true;
          if (g.team) box.insertBefore(btn, box.querySelector('[data-lt-soon]'));
          else box.insertAdjacentElement('afterend', btn);
        }
        const items = all.filter((el) => !el.hidden);
        const key = facetKey(box);
        const open = expandedFacets.has(key);
        const extra = items.slice(CAP).filter((el) => {
          const i = el.querySelector('input');
          return !(i && i.checked);
        });
        if (items.length <= CAP || extra.length === 0 || (g.team && q !== '')) {
          btn.hidden = true;
          return;
        }
        btn.hidden = false;
        btn.dataset.key = key;
        btn.setAttribute('aria-expanded', String(open));
        if (open) {
          btn.textContent = 'Show less';
        } else {
          extra.forEach((el) => el.classList.add('lt-capped'));
          btn.textContent = 'Show more (' + extra.length + ')';
        }
      });
    });
  };
  const toggleCap = (btn) => {
    const key = btn.dataset.key;
    if (expandedFacets.has(key)) expandedFacets.delete(key);
    else expandedFacets.add(key);
    capLists();
  };

  /* ---------- mobile panel ---------- */
  const openPanel = (btn) => {
    const panel = $('[data-lt-filterpanel]');
    if (!panel) return;
    panelOpen = true;
    opener = btn || null;
    panel.classList.add('is-open');
    panel.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('lt-panel-open');
    panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
    if (btn && btn.hasAttribute('data-lt-focus-sort')) {
      const sort = $('.lt-facet--sort', panel);
      if (sort) sort.scrollIntoView({ block: 'start' });
    }
  };
  const closePanel = () => {
    const panel = $('[data-lt-filterpanel]');
    panelOpen = false;
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-modal', 'false');
    }
    document.documentElement.classList.remove('lt-panel-open');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  };
  mobile.addEventListener('change', () => {
    if (!mobile.matches && panelOpen) closePanel();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panelOpen) closePanel();
  });

  /* ---------- events (delegated; the inner markup is replaced on every filter change) ---------- */
  root.addEventListener('click', async (e) => {
    const sm = e.target.closest('[data-lt-showmore]');
    if (sm) {
      e.preventDefault();
      toggleCap(sm);
      return;
    }
    const nav = e.target.closest('a[data-lt-nav]');
    if (nav && !e.metaKey && !e.ctrlKey && !e.shiftKey && nav.getAttribute('aria-disabled') !== 'true') {
      e.preventDefault();
      navigate(nav.href);
      return;
    }
    const open = e.target.closest('[data-lt-open-panel]');
    if (open) {
      openPanel(open);
      return;
    }
    if (e.target.closest('[data-lt-close-panel]')) {
      closePanel();
      return;
    }
    const mine = e.target.closest('[data-lt-mine]');
    if (mine) {
      const form = $('[data-lt-form]');
      const facet = $('[data-lt-team-facet]');
      const opt = $$('.lt-opt--team', facet).find((o) => (o.dataset.teamLabel || '').toLowerCase() === (mine.dataset.team || '').toLowerCase());
      if (!form || !opt) return;
      const input = $('input', opt);
      const on = mine.getAttribute('aria-pressed') === 'true';
      $$('.lt-opt--team input', facet).forEach((i) => (i.checked = false));
      input.checked = !on;
      navigate(urlFor(paramsFrom(form)));
      return;
    }
    const more = e.target.closest('[data-lt-more]');
    if (more) {
      more.disabled = true;
      more.textContent = 'Loading';
      try {
        const res = await fetch(more.dataset.href, { headers: { Accept: 'text/html' } });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = $('[data-lt-grid]');
        const incoming = doc.querySelectorAll('[data-lt-grid] .lt-cat__cell');
        incoming.forEach((c) => grid.appendChild(document.importNode(c, true)));
        const showing = $('[data-lt-showing]');
        const nextBtn = doc.querySelector('[data-lt-more]');
        const total = Number(showing.dataset.total);
        const nowShown = Math.min(total, grid.querySelectorAll('.lt-cat__cell').length);
        showing.dataset.shown = String(nowShown);
        showing.textContent = `Showing ${nowShown} of ${total}`;
        if (nextBtn) {
          more.dataset.href = nextBtn.dataset.href;
          more.disabled = false;
          more.textContent = 'Load more';
        } else {
          more.remove();
        }
      } catch (err) {
        more.disabled = false;
        more.textContent = 'Load more';
      }
    }
  });

  root.addEventListener('change', (e) => {
    const form = $('[data-lt-form]');
    if (!form) return;
    if (e.target.matches('[data-lt-sort-select]')) {
      navigate(urlFor(paramsFrom(form, { sort_by: e.target.value })));
      return;
    }
    if (e.target.closest('[data-lt-form]') && !e.target.matches('[data-lt-team-search]')) {
      navigate(urlFor(paramsFrom(form)));
    }
  });
  root.addEventListener('input', (e) => {
    if (e.target.matches('[data-lt-team-search]')) { filterTeams(e.target.value); capLists(); }
  });
  root.addEventListener('submit', (e) => {
    if (e.target.matches('[data-lt-form]')) {
      e.preventDefault();
      navigate(urlFor(paramsFrom(e.target)));
    }
  });

  /* ---------- start ---------- */
  badge();
  capLists();
  const ready = () => {
    teamFacet();
    ensureChips();
    capLists();
    document.addEventListener('lt:myteam', () => { teamFacet(); capLists(); });
  };
  if (window.LT && window.LT.teams) ready();
  else document.addEventListener('lt:ready', ready, { once: true });
})();
